import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EditIcon } from '../../../../../../../../design/static/icons/EditIcon';

interface IProps {
  onShowModal: () => Promise<void>;
  disabled?: boolean;
}

export const EditMarkingToolButton = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <IconButton
      size='sm'
      color='primary'
      onClick={() => {
        void props.onShowModal();
      }}
      title={t('edit')}
      disabled={props.disabled}
    >
      <EditIcon />
    </IconButton>
  );
});
